export const useDocumentContainerRightPosition = () => {
  try {
    var documentContainerElement =
      document.getElementById("document-container");
    if (!documentContainerElement) {
      return window.innerWidth;
    }

    var documentBox = documentContainerElement.getBoundingClientRect();

    if (
      documentBox == undefined ||
      documentBox.left == undefined ||
      documentBox.width == undefined
    )
      return window.innerWidth;

    return documentBox.left + documentBox.width;
  } catch (error) {
    if (window != undefined && window.innerWidth != undefined)
      return window.innerWidth;

    return 0;
  }
};
